import useHasTransitionError from "hooks/useHasTransitionError"
import { useEffect, useState } from "react"

export const useFRModal = () => {
  const [isFRModalOpen, setIsFRModalOpen] = useState(false)

  const {
    remoteErrors,
    hasTransitionError
  } = useHasTransitionError()

  useEffect(_handleHasFRError, [remoteErrors])

  function _handleHasFRError() {
    const divergentErrorSlug = 'federal_revenue_divergent_data'
    const hasDivergentError = hasTransitionError(divergentErrorSlug)
    
    setIsFRModalOpen(hasDivergentError)
  }
  function closeFRModal() {
    setIsFRModalOpen(false)
  }
  
    
  return {
    isFRModalOpen,
    closeFRModal
  }
}

export const useEmailModal = () => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false)

  const {
      remoteErrors,
      hasTransitionError
  } = useHasTransitionError()

  useEffect(_handleHasEmailError, [remoteErrors])

  function _handleHasEmailError() {
      const errorSlug = 'email_not_allowed'
      const hasErrorEmail = hasTransitionError(errorSlug)

      setIsEmailModalOpen(hasErrorEmail)
  }
  function closeEmailModal() {
      setIsEmailModalOpen(false)
  }


  return {
      isEmailModalOpen,
      closeEmailModal
  }
}

export const usePhoneModal = () => {
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false)

  const {
    remoteErrors,
    hasTransitionError
  } = useHasTransitionError()

  useEffect(_handleHasPhoneError, [remoteErrors])

  function _handleHasPhoneError() {
    const errorSlug = 'phone_not_allowed'
    const hasErrorPhone = hasTransitionError(errorSlug)

    setIsPhoneModalOpen(hasErrorPhone)
  }
  function closePhoneModal() {
    setIsPhoneModalOpen(false)
  }


  return {
    isPhoneModalOpen,
    closePhoneModal
  }
}